module.exports = __webpack_public_path__ + "media/savings_calculator/cost_proj_btn-f8db5413.png";